<template>
  <div class="container">
    <div class="breadcrumb-list">
      <ol class="breadcrumb">
        <li class="breadcrumb-item active"><span style="font-size: 13px; font-weight: bold;">Employee Name:</span> <span style="color: blue;">{{ employee.name }}</span></li>
      </ol>
    </div>
    <div class="attendance-report tbl-responsive">
      <div class="input-wrap w-348 d-flex mb-10 align-items-center dropdown-toggle dates-select">
        <div class="input-wrap w-348 d-flex mb-10 align-items-center select-drop">
          <h2 class="mb-0"> Time Sheet for Week {{ allDates }}</h2>
        </div>
      </div>
      <table class="client-table table-striped">
        <thead>
        <tr>
          <th>Project Name</th>
          <th>Product Activity</th>
          <th v-for="(date, index) in dates" :key="index" :class="'dateTime'+index" :data-hours="date.hours">
            {{ date.date }}
          </th>
          <!-- <th>Total</th> -->
        </tr>
        </thead>
        <tbody v-if="!loadingSpin && tableRows">
        <tr v-for="(row,rowIndex) in tableRows" :key="rowIndex" :id="'tableRows'+rowIndex">
          <td>
            <div class="input-wrap wrap-width ">
              <select class="form-select form-control" :id="'projectInput_'+rowIndex"
                      @change="getAllActivities($event,rowIndex+'act')" v-model="row.project_id" readonly
                      @mousedown.prevent>
                <option class="ab-cstplace" v-for="(project, index) in projects" :key="index" :value="project.id">
                  {{ project.name }}
                </option>
              </select>
            </div>
          </td>
          <td>
            <div class="input-wrap wrap-width">
              <select class="form-select form-control activity-validation" :id="'activityInput_'+rowIndex"
                      v-model="row.activity_id" @change="validationTimeSheet()" readonly @mousedown.prevent>
                <option v-for="(activity, index) in projectActivities[rowIndex+'act']" :key="index"
                        :value="activity.id"> {{ activity.name }}
                </option>
              </select>
            </div>
          </td>
          <td v-for="(dat,ind) in row.dates" :key="ind">
            <div class="input-wrap">
              <input type="text" class="form-control" :class="'timeSpent_'+ind" :id="'timeInput_'+rowIndex+'_'+ind"
                     :value="dat.hours" @focusout="validateTime($event,ind)" readonly @mousedown.prevent/>
              <a href="javascript:void(0);" class="msg-modal" data-toggle="modal"
                 :data-target="'#messageModal_'+rowIndex+'_'+ind">
                <span class="ico-message-icon"></span>
              </a>
            </div>
            <div class="my-modal modal fade" :id="'messageModal_'+rowIndex+'_'+ind">
              <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                  <div class="modal-body p-20">
                    <h5 class="modal-title text-left">Add Message:</h5>
                    <textarea rows="4" class="txtarea-responsive"
                              :id="'noteInput_'+rowIndex+'_'+ind">{{ dat.notes }}</textarea>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal"
                      >
                        Close
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary"
                        data-dismiss="modal"
                      >
                        Save changes
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
        <tbody v-if="!loadingSpin && tableRows.length==0">
        <tr>
          <td colspan="10">
            No Data Found
          </td>
        </tr>
        </tbody>
      </table>
      <div class="d-flex justify-content-center">
        <clip-loader :loading="loadingSpin" :size="size" :color="spinnerColor"></clip-loader>
      </div>

      <!-- <div class="tbl-bottom-btn">
          <div class="btns-right" v-for="(AllTimeSheet, index) in AllTimeSheets" :key="index"  >
              <router-link :to="'/timesheet/edit/'+AllTimeSheet.employee.uuid" :key="index" tag="span"
                  class="btn btn-outline-primary" style="cursor: pointer;">
                  Edit
              </router-link>
          </div>
      </div> -->

      <div class="tbl-bottom-btn">
        <div class="btns-right">
          <router-link :to="'/timesheet/edit/'+this.$route.params.id+'/'+tid" tag="span" class="btn btn-outline-primary"
                       style="cursor: pointer;">
            Edit
          </router-link>
        </div>
      </div>


    </div>
    <div class="card my-10" v-if="employeeWeeklyTimeSheet && employeeWeeklyTimeSheet.status=='Submit'">
      <div class="card-body">
        <h6>Actions Performed on the TimeSheet</h6>
        <div class="row">
          <div class="col-6 my-10">
            <label>Comment: </label>
            <textarea v-model="timeSheetNote"></textarea>
          </div>
          <div class="col-12 mt-10">
            <button class="btn btn-primary" @click="approveTimesheet()">Approve</button>
            <button class="btn btn-danger" @click="RejectTimesheet()">Reject</button>
          </div>
        </div>
      </div>
    </div>

    <div class="card my-10"
         v-if="employeeWeeklyTimeSheet && (employeeWeeklyTimeSheet.status=='Approved'|| employeeWeeklyTimeSheet.status=='Rejected')">
      <div class="card-body">
        <div class="row">
          <div class="col-12">
            <h6>Actions Performed on the TimeSheet</h6>
            <table class="client-table">
              <thead>
              <tr>
                <th>Action</th>
                <th>Performed By</th>
                <th>Date</th>
                <th>Comment</th>
              </tr>
              </thead>
              <tbody>
              <tr>
                <td>{{employeeWeeklyTimeSheet.status}}</td>
                <td>{{employeeWeeklyTimeSheet.user.name}}</td>
                <td>{{employeeWeeklyTimeSheet.approved_date}}</td>
                <td>{{employeeWeeklyTimeSheet.note}}</td>

              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div class="card my-10" v-if="employeeWeeklyTimeSheet && employeeWeeklyTimeSheet.status=='Pending'">
      <div class="card-body">

       <h6 class="text-center notSubmit">
         The timesheet has not yet been submitted by the employee.
       </h6>
        </div>
      </div>
  </div>
</template>
<script>

import moment from "moment";
import ClipLoader from 'vue-spinner/src/ClipLoader.vue';
import Multiselect from "vue-multiselect";
import DateWithNotes from "./dateWithNotes.vue";


export default {
  name: "editTimeSheet",
  components: {
    Multiselect,
    DateWithNotes,
    ClipLoader
  },
  data() {
    return {
      size: '25px',
      spinnerColor: '#00779C',
      loadingSpin: false,
      selectedCompany: this.$store.getters.getSelectedCompany,
      company_id: this.$store.getters.getSelectedCompany.id,
      tableRows: [],
      employee: {},
      projectUnderWork: [],
      timeSheetNote: '',
      activityUnderWork: '',
      projectActivities: [],
      selected: [],
      userAttendances: [],
      activities: [],
      allDates: '',
      selectedProjects: [],
      weekDates: [],
      date: "",
      startDate: [],
      endDay: [],
      // employee: [],
      employeeOptions: [],
      AllTimeSheets: [],
      endDate: [],
      startDay: [],
      dates: [],
      Activityname: [],
      activitiesId: [],
      Alldata: [],
      count: 1,
      savedData: [],
      myDates: [],
      Allids: [],
      projectId: "",
      emlpoyeeTimeSheet: [],
      projects: [],
      sortedAttendances: '',
      timeCheckBtn: false,
      errorMessage: false,
      sheetData: [],
      user: this.$store.getters.getUser,
      TemProjectActivities: [],
      employeeWeeklyTimeSheet: "",
      tid : this.$route.params.tid
    };
  },

  created() {
    this.getProjects();

  },

  methods: {
    validationTimeSheet() {
      this.timeCheckBtn = this.errorMessage = false;
      $('.activity-validation').css("border-color", "#bebebe");
      let validation = [];
      this.tableRows.forEach(function (elem, indx) {
        let curentRow = $('#activityInput_' + indx).val() + '_' + $('#projectInput_' + indx).val()
        if (validation.includes(curentRow)) {
          if (curentRow.search("null")) {
            let errorIndex = validation.indexOf(curentRow);
            $('#activityInput_' + errorIndex).css("border-color", "red");
            $('#activityInput_' + indx).css("border-color", "red");
          }
        }
        validation.push(curentRow);
      })
    },
    validateTime(event, indx) {
      let self = this;
      self.timeCheckBtn = false;
      self.errorMessage = false;
      let totalWorkedHours = $('.dateTime' + indx).attr('data-hours');
      $(event.target).css("border-color", "#bebebe");

      let totalTimeSpent = [];
      let timeSpent = [];
      for (let i = 0; i < self.tableRows.length; i++) {
        let rowTimeValidation = self.tableRows[i];
        rowTimeValidation.dates.forEach(function (row, ridx) {
          let enterHrs = $('#timeInput_' + i + '_' + ridx).val();
          if (enterHrs) {
            let timeFormat = enterHrs.split(":");
            if (timeFormat.length == 1) {
              timeFormat[1] = (timeFormat[1]) ? timeFormat : '00';
              enterHrs = timeFormat.join(':');
            }
            let newHrs = moment.duration(enterHrs).asMinutes()
            if (timeSpent[ridx] == undefined) {
              timeSpent[ridx] = newHrs;
            } else {
              let totalHrs = timeSpent[ridx];
              timeSpent[ridx] = parseFloat(totalHrs) + parseFloat(newHrs);
            }
          } else {
            timeSpent.push(enterHrs);
          }
          let rowTotalHrs = $('.dateTime' + ridx).attr('data-hours');
          if (enterHrs && rowTotalHrs != undefined) {
            self.tableRows[i].dates[ridx].hours = enterHrs
          }
        })
      }
      timeSpent.forEach(function (hrs, hrsidx) {
        let rowTotalHrs = $('.dateTime' + hrsidx).attr('data-hours');
        $('.timeSpent_' + hrsidx).css("border-color", "#bebebe");
        if (rowTotalHrs == undefined) {
          $('.timeSpent_' + hrsidx).val('');
        } else {
          rowTotalHrs = moment.duration(rowTotalHrs).asMinutes();
          if (rowTotalHrs < hrs) {
            $('.timeSpent_' + hrsidx).css("border-color", "red");
            self.timeCheckBtn = self.errorMessage = true;
          }
        }
      })
    },
    approveTimesheet() {
      this.loadingSpin = true;
      let params = {
        id: this.employeeWeeklyTimeSheet.id,
        employee_id: this.$route.params.id,
        status: 'Approved',
        note: this.timeSheetNote,
      };
      this.$axios.get(this.$StatusTimeSheet, {
        params: params,
        headers: this.getAuthHeader(),
      })
        .then((res) => {
          if (res.data.status === 200) {
            this.employeeWeeklyTimeSheet = res.data.result;
            $root.$toast.success('Submitted Successfully');
          }
        });
      this.loadingSpin = false;
    },
    RejectTimesheet() {
      this.loadingSpin = true;
      let params = {
        id: this.employeeWeeklyTimeSheet.id,
        employee_id: this.$route.params.id,
        status: 'Pending',
        note: this.timeSheetNote,
      };
      this.$axios.get(this.$StatusTimeSheet, {
        params: params,
        headers: this.getAuthHeader(),
      })
        .then((res) => {
          if (res.data.status === 200) {
            this.employeeWeeklyTimeSheet = res.data.result;
            $root.$toast.success('Submitted Successfully');
          }
        });
      this.loadingSpin = false;
    },
    getTimesheetDates() {
      this.loadingSpin = true;
      let id  = this.$route.params.id;
      let tid = this.$route.params.tid;
      let params = {
        company_id: this.selectedCompany.id,
        employee_uuid: id,
        tid: tid,
      };

      this.$axios.get(this.$timeSheetDates, {
        params: params,
        headers: this.getAuthHeader(),
      })
        .then((res) => {
          this.employee = res.data.result.userWithAttendance;
          // this.weekDates = res.data.result.weeks;2024-01-01 - 2024-01-07
          this.employeeWeeklyTimeSheet          = res.data.result.employeeWeeklyTimeSheet;
          this.weekDates = [this.employeeWeeklyTimeSheet.start_date+' - '+this.employeeWeeklyTimeSheet.end_date];
          this.userAttendances = res.data.result.userWithAttendance.attendances;
          this.sortedAttendances = res.data.result.userWithAttendance.sorted_attendances;
          this.getTimesheet();
        });
    },
    getAttendancesAndDates() {
      let dateArr = this.allDates.split(' - ');
      let params = {
        startDate: dateArr[0],
        endDate: dateArr[1],
        employee_id: this.$route.params.id,
      };
      this.$axios.get(this.$GetAttendancesForTimeSheet, {
        params: params,
        headers: this.getAuthHeader(),
      })
        .then((res) => {
          this.sortedAttendances = res.data.result.userWithAttendance.sorted_attendances;
          this.printDates();
        });
    },
    getTimesheet(id = null) {
      id = this.$route.params.id;
      let params = {
        dates: this.weekDates[0],
        employee_uuid: id,
      };
      this.$axios.get(this.$getEmployeeTimeSheet, {
        params: params,
        headers: this.getAuthHeader(),
      }).then((res) => {
        if (res.data.status === 200) {
          let sheetData = res.data.result;
          let startDate = sheetData ? sheetData.start_date : null;
          let endDate = sheetData ? sheetData.end_date : null;
          let self = this;
          this.allDates = startDate !== null ? startDate + " - " + endDate : this.weekDates[0];
          this.printDates();
          if (sheetData) {
            self.tableRows = [];
            let rowsData = Object.values(sheetData.groupedtimesheet);
            rowsData.forEach((item, index) => {
              let project_id = item[0]?.project_id || null;
              let activity_id = item[0]?.activity_id || null;

              self.tableRows.push({
                dates: item,  // Keep this as is, so `dates` is an array
                project_id: project_id,
                activity_id: activity_id
              });

              // Make sure projectActivities is initialized and reactive
              this.$set(this.projectActivities, index + 'act', this.TemProjectActivities[project_id]);
            });
          }
        }
      });
    },

    getTimesheet_old(id = null) {
      id = this.$route.params.id;
      let params = {
        dates: this.weekDates[0],
        employee_uuid: id,
      };
      this.$axios.get(this.$getEmployeeTimeSheet, {
        params: params,
        headers: this.getAuthHeader(),
      }).then((res) => {
        if (res.data.status === 200) {
          let sheetData = res.data.result;
          let startDate = sheetData ? sheetData.start_date : null;
          let endDate = sheetData ? sheetData.end_date : null;
          let self = this;
          this.allDates = startDate !== null ? startDate + " - " + endDate : this.weekDates[0];
          this.printDates();
          if (sheetData) {
            self.tableRows = [];
            console.log(sheetData.groupedtimesheet,'itema');
            let rowsData = Object.values(sheetData.groupedtimesheet);
            rowsData.forEach((item, index) => {
              self.tableRows.push({
                dates: item,
                project_id: item[index].project_id,
                activity_id: item[index].activity_id
              });
              this.projectActivities[index + 'act'] = this.TemProjectActivities[item[index].project_id];
            })
          }
        }
      });
    },

    getProjects() {
      this.loadingSpin = true;
      let params = {
        company_id: this.selectedCompany.id,
      };
      this.$axios.get(this.$GetProjects, {
        params: params,
        headers: this.getAuthHeader(),
      })
        .then((res) => {
          if (res.data.status === 200) {
            this.projects = res.data.result;
            this.projects.forEach((item) => {
              // this.projectActivities.push(item.activities);
              this.TemProjectActivities[item.id] = item.activities;
            })
            this.getTimesheetDates();
            // this.getTimesheet();
          }
        });
    },
    getAllActivities(event, indx) {
      let activity = [];
      this.projects.map((pro) => {
        if (pro.id == parseInt(event.target.value)) {
          activity = pro.activities;
        }
      });
      this.projectActivities[indx] = activity;
      // Make proper index for activity validation
      this.validationTimeSheet();
    },
    selectedcustomer_id(id) {
      var ids = [];
      $("input:checked.customer_id_ckbx").each((ind, element) => {
        let id = $(element).val();
        if (!ids.includes(id)) {
          ids.push(id);
        }
      });
      this.Allids = ids;
    },
    printDates() {
      let arr = this.allDates.split(' - ');
      this.startDate = arr[0];
      this.endDate = arr[1];
      this.dates = [];
      const m = moment(arr[0]);
      const m2 = moment(arr[1]);
      this.startDay = m.format("D");
      this.endDay = m2.format("D");
      this.myDates = [];
      this.tableRows = [];
      for (var d = moment(this.startDate); d.isSameOrBefore(this.endDate); d.add(1, "days")) {
        let addDateFlag = 0;
        let timeDiffArr = [];
        if (d.format("YYYY-MM-DD") in this.sortedAttendances) {
          Object.values(this.sortedAttendances[d.format("YYYY-MM-DD")]).map((attend) => {
            let start = moment(attend.punch_in_time, "YYYY-MM-DD HH:mm:ss");
            let outTime = (attend.punch_out_time) ? attend.punch_out_time : moment().format('YYYY-MM-DD HH:mm:ss');
            let end = moment(outTime, "YYYY-MM-DD HH:mm:ss");
            var hours = end.diff(start, 'hours');
            var minutes = moment.utc(moment(end, "HH:mm:ss").diff(moment(start, "HH:mm:ss"))).format("mm");
            // timeDiffArr.push(`${hours}:${minutes}`);
            timeDiffArr.push(this.calculateAttendanceTimes(attend));
          })
          const sum = timeDiffArr.reduce((acc, time) => acc.add(moment.duration(time)), moment.duration());
          let minutCount = sum.minutes() < 10 ? '0' + sum.minutes() : sum.minutes();
          let calHours = [Math.floor(sum.asHours()), minutCount].join(':');
          this.dates.push({date: d.format("ddd DD") + ' - ' + calHours, hours: calHours});
          addDateFlag++;
        }
        if (addDateFlag == 0) {
          this.dates.push({date: d.format("ddd DD") + ' - Not Worked', hours: null});
        }
        this.myDates.push({
          date: d.format("YYYY-MM-DD"),
          hours: null,
          comment: null,
          notes: null
        });
        // this.count++;
      }
      this.Alldata = {
        start_date: this.startDate,
        end_date: this.endDate,
        status: null,
        sheet: [],
      };
      // this.tableRows.push({dates:this.myDates});
      this.loadingSpin = false;
    },
  },
  computed: {},
};
</script>
<style scoped>
.ab-cstplace {
  font-size: 14px;
  color: #adadad;
  display: block;
}

.input-wrap {
  position: relative;
}

.multiselect__select,
.multiselect__select:before {
  display: none !important;
}

.dates-select {
  position: relative;
}

.dropdown-toggle::after {
  margin-left: -15px;
  z-index: 2;
}

.modal-body {
  padding-bottom: 0px;
}

.url-inputs {
  margin: 10px 10px 10px;
}

.ab-select {
  margin-right: 0px !important;
}
.client-table th {
  padding: 14px 5px !important;
}
.notSubmit{
  color: red;
}
@media (min-width: 1600px) {
  .wrap-width {
    width: 300px !important;
  }
}

</style>
